import {useState, useCallback} from 'react';
import {listAdjustWithWp} from '@/services/auditService/auditAdjustOrchestrate';
import type {AuditAdjustHeader} from '@/services/auditService/interface/adjust-orchestrate';

/**
 * Reusable hook for managing AdjustmentDetailsDrawer state + API calls.
 * Used by all Wp components to render the drawer as a sibling with OverlayMask.
 */
export function useAdjustmentDetailsDrawer() {
    const [open, setOpen] = useState(false);
    const [headerData, setHeaderData] = useState<AuditAdjustHeader[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [itemName, setItemName] = useState('');

    const handleOpen = useCallback(async (headerIds: string[], name: string) => {
        if (!headerIds || headerIds.length === 0) return;
        const uniqueIds = [...new Set(headerIds)];
        setItemName(name);
        setHeaderData(null);
        setLoading(true);
        setOpen(true);
        try {
            const result = await listAdjustWithWp(uniqueIds);
            setHeaderData(Array.isArray(result) ? result : []);
        } catch (e) {
            console.error('[useAdjustmentDetailsDrawer] Failed to fetch adjustment details:', e);
            setHeaderData([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleClose = useCallback(() => setOpen(false), []);

    return {open, headerData, loading, itemName, handleOpen, handleClose};
}
